import {Flex} from "antd";
import {FaCheck, FaTimes} from "react-icons/fa";

export const successIcon = <FaCheck
    fontSize={'18px'}
    color={'green'}/>;

export const failureIcon = <FaTimes
    fontSize={'18px'}
    color={'red'}/>;

export function renderStatusIcon(value: boolean) {
    return value ? successIcon : failureIcon;
}

export const renderPairItem = (value: any) => {
    if (value?.name == null && value?.value == null) {
        return <></>
    }

    if (value?.name == null) {
        return value?.value;
    }

    return (
        <Flex>
            <div style={{width: '40%'}}><b>{value?.name}</b></div>
            <div style={{width: '60%'}}>{value?.value}</div>
        </Flex>
    );
};

export function areStringsEqual(...strings: (string | null)[]) {
    if (!strings) {
        throw 'can not be empty';
    }

    if (strings.length < 2) {
        throw 'should contains at least two strings';
    }

    if (strings.some(s => s === null)) {
        return false;
    }

    // @ts-ignore
    const s0 = strings[0].toLowerCase();

    return strings.slice(1).every(s => s!.toLowerCase() === s0);
}

export const USD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export function groupBy<T>(items: T[], selector: (item: T) => string): { [key: string]: T[] } {
    const result: { [key: string]: T[] } = {};

    items.forEach((item) => {
        const key = selector(item);

        if (!result[key]) {
            result[key] = [];
        }

        result[key].push(item);
    });

    return result;
}